import React, { useState, useEffect } from "react";
import axios from "axios";

import ImageStaticMap from "../Media/ImageStaticMap";

const LegalAidOrgsList = ({ state }) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const source = axios.CancelToken.source();

    const fetchProviders = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${UPSOLVE_API_URL}/v1/content/legalServiceProviders`, {
          cancelToken: source.token,
        });
        setProviders(response.data);
        setError(null);
      } catch (err) {
        if (!axios.isCancel(err)) {
          setError("Failed to fetch legal service providers");
          console.error(`Error fetching providers (${UPSOLVE_API_URL}/v1/content/legalServiceProviders):`, err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();

    return () => {
      source.cancel("Component unmounted");
    };
  }, []);

  if (!state) return null;
  if (loading) return <div>Loading legal aid organizations...</div>;
  if (error) return <div>Error: {error}</div>;

  const filtered = providers.filter((p) => p.state && p.state.toLowerCase() === state.toLowerCase());

  return (
    <div>
      {filtered.map((la) => (
        <div key={la.name}>
          <p>
            <a href={la.link || la.url || ""} target="_blank" rel="noopener noreferrer">
              {la.name}
            </a>
            <br />
            {la.phone || la.phoneNumber}
            <br />
            {la.address}
            <ImageStaticMap alt={`${la.name} Location`} address={la.address} />
          </p>
        </div>
      ))}
      <div>
        <p>
          <a href="/">Upsolve</a>
          <br />
          Nationwide Service (NYC Office)
        </p>
        <ImageStaticMap
          alt="Upsolve Location"
          number="150"
          street="Court Street"
          city="New York City"
          state="NY"
          zipcode="11201"
        />
      </div>
    </div>
  );
};

export default LegalAidOrgsList;
